import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function LossModal({ lossModal, lossForm, setLossModal, setLossForm, submitLossReport }) {
  if (!lossModal) return null;
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={e => { if (e.target === e.currentTarget) setLossModal(null); }}>
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
        <div className="px-6 py-4 border-b">
          <h3 className="font-semibold text-lg flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-red-500" />Report Loss / Theft</h3>
          <p className="text-xs text-gray-500 mt-1">Creates an approval request — stock is only deducted after manager approval</p>
        </div>
        <div className="p-6 space-y-4">
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-sm font-semibold">{lossModal.name}</p>
            <p className="text-xs text-gray-500">{lossModal.sku} — Current stock: <span className="font-semibold">{lossModal.stock}</span> — Value per unit: S${lossModal.cost || 0}</p>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Quantity Lost *</label>
            <input type="number" min="1" max={lossModal.stock} value={lossForm.quantity}
              onChange={e => setLossForm(p => ({ ...p, quantity: Math.min(parseInt(e.target.value) || 1, lossModal.stock) }))}
              className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-400" />
            <p className="text-xs text-red-500 mt-1">Estimated loss value: S${((parseInt(lossForm.quantity) || 0) * (lossModal.cost || 0)).toFixed(2)}</p>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Category *</label>
            <select value={lossForm.category} onChange={e => setLossForm(p => ({ ...p, category: e.target.value }))} className="w-full border rounded-lg px-3 py-2 text-sm">
              <option value="theft">Theft</option>
              <option value="damage">Damage / Broken</option>
              <option value="expired">Expired / Spoiled</option>
              <option value="miscount">Miscounted / Inventory Error</option>
              <option value="transit_loss">Lost in Transit</option>
              <option value="sample">Given as Sample / Demo</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Description *</label>
            <textarea value={lossForm.reason} onChange={e => setLossForm(p => ({ ...p, reason: e.target.value }))}
              className="w-full border rounded-lg px-3 py-2 text-sm h-20 resize-none focus:outline-none focus:ring-2 focus:ring-red-400"
              placeholder="What happened? When was the loss discovered?" />
          </div>
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Evidence / Reference</label>
            <input type="text" value={lossForm.evidence} onChange={e => setLossForm(p => ({ ...p, evidence: e.target.value }))}
              className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-400"
              placeholder="CCTV ref, police report #, photo link, etc." />
          </div>
        </div>
        <div className="flex justify-end gap-3 px-6 py-4 border-t">
          <button onClick={() => setLossModal(null)} className="px-4 py-2 text-sm text-gray-600 border rounded-lg hover:bg-gray-50">Cancel</button>
          <button onClick={submitLossReport} disabled={!lossForm.reason.trim() || !lossForm.quantity}
            className="px-4 py-2 text-sm bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:bg-gray-300 font-medium">Submit Loss Report</button>
        </div>
      </div>
    </div>
  );
}
